// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedContactGlassDirect_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H10V5.09679C10.6504 5.03313 11.3186 5 12 5C12.6814 5 13.3496 5.03313 14 5.09679V0H16V5.39831C20.6608 6.35927 24 8.95216 24 12C24 15.0478 20.6608 17.6407 16 18.6017V24H14V18.9032C13.3496 18.9669 12.6814 19 12 19C11.3186 19 10.6504 18.9669 10 18.9032V24H8V18.6017C3.33923 17.6407 0 15.0478 0 12C0 8.95216 3.33923 6.35926 8 5.39831V0ZM16 16.5542C17.344 16.2405 18.5244 15.7782 19.4775 15.2222C21.3417 14.1348 22 12.9263 22 12C22 11.0737 21.3417 9.86523 19.4775 8.77781C18.5244 8.22181 17.344 7.7595 16 7.44581V16.5542ZM14 7.10733V16.8927C13.3567 16.9627 12.6883 17 12 17C11.3117 17 10.6433 16.9627 10 16.8927V7.10733C10.6433 7.03727 11.3117 7 12 7C12.6883 7 13.3567 7.03727 14 7.10733ZM4.52246 8.77781C5.4756 8.22181 6.65603 7.7595 8 7.44581V16.5542C6.65603 16.2405 5.4756 15.7782 4.52246 15.2222C2.65832 14.1348 2 12.9263 2 12C2 11.0737 2.65832 9.86523 4.52246 8.77781Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0H13V7.15795C13.9718 7.05426 14.9746 7 16 7C17.0254 7 18.0282 7.05426 19 7.15795V0H21V7.44818C27.3879 8.62919 32 12.0116 32 16C32 19.9884 27.3879 23.3708 21 24.5518V32H19V24.8421C18.0282 24.9457 17.0254 25 16 25C14.9746 25 13.9718 24.9457 13 24.8421V32H11V24.5518C4.61214 23.3708 0 19.9884 0 16C0 12.0116 4.61214 8.62919 11 7.44818V0ZM21 22.515C23.0625 22.0994 24.8785 21.4391 26.3332 20.6208C28.9399 19.1545 30 17.4418 30 16C30 14.5582 28.9399 12.8455 26.3332 11.3792C24.8785 10.5609 23.0625 9.90055 21 9.48503V22.515ZM19 9.17013V22.8299C18.037 22.9409 17.0338 23 16 23C14.9662 23 13.963 22.9409 13 22.8299V9.17013C13.963 9.05912 14.9662 9 16 9C17.0338 9 18.037 9.05912 19 9.17013ZM5.66681 11.3792C7.1215 10.5609 8.93753 9.90055 11 9.48503V22.515C8.93753 22.0995 7.1215 21.4391 5.66681 20.6208C3.06005 19.1545 2 17.4418 2 16C2 14.5582 3.06005 12.8455 5.66681 11.3792Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedContactGlassDirect is a generated icon component.
 */
let IconMedContactGlassDirect = IconMedContactGlassDirect_1 = class IconMedContactGlassDirect extends IconBaseElement {
    render() {
        return html `${IconMedContactGlassDirect_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedContactGlassDirect.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedContactGlassDirect = IconMedContactGlassDirect_1 = __decorate([
    customElement('zui-icon-med-contact-glass-direct')
], IconMedContactGlassDirect);
export { IconMedContactGlassDirect };
